var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketmodalBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 485,
    height: 147,
    viewBox: "0 0 485 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_306_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.043 4C359.029 4.21979 359.019 4.44075 359.019 4.66406C359.019 10.0448 363.267 14.4057 368.509 14.4062C373.75 14.4057 377.999 10.0448 377.999 4.66406C377.999 4.44075 377.989 4.21979 377.975 4H469.66C475.922 4 480.998 9.21075 480.998 15.6387V52.6836C471.952 52.6854 464.62 60.214 464.62 69.5C464.62 78.7863 471.952 86.3146 480.998 86.3164V131.361C480.998 137.789 475.922 143 469.66 143H377.999C377.999 137.619 373.75 133.257 368.509 133.257C363.267 133.257 359.019 137.619 359.019 143H15.3379C9.07616 143 4.0001 137.789 4 131.361V86.3164C13.0451 86.3138 20.377 78.7857 20.377 69.5C20.377 60.2143 13.0451 52.6862 4 52.6836V15.6387C4.00011 9.21079 9.07616 4.00006 15.3379 4H359.043Z",
    fill: "url(#paint0_linear_306_29)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M369 17C369 64.0382 369 84.6862 369 131.724",
    stroke: "#C1BFBF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "5 7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_306_29",
    x: 0,
    y: 0,
    width: 484.998,
    height: 147,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_306_29"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_306_29",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_306_29",
    x1: 481.001,
    y1: 129.5,
    x2: 44.1639,
    y2: -61.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFCFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketmodalBg);
export default __webpack_public_path__ + "static/media/ticketmodal-bg.bf4d52e5cbb256e90978f28426476197.svg";
export { ForwardRef as ReactComponent };